import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../appStore";
import { EAppReducers } from "../../white-list";

const getState = (state: RootState) => state[EAppReducers.LESSON];

export const lessonSelector = createSelector(getState, (state) => state);
